// Human-readable role labels (v3 vocabulary) mapped from backend enums
export const roleLabel = (role) => ({
  Admin: "Super Admin",
  Approver: "Authorizer",
  Authorizer: "Authorizer",
  Employee: "Team Member",
  ProjectManager: "Project Manager",
  Accounts: "Accounts",
  Auditor: "Auditor",
  Trustee: "Trustee Approver",
  MEL: "MEL Manager",
}[role] || role);

// NEW rule (2026-02-11): Sanctioned budget visibility is Super Admin + Accounts only.
// Authorizer, Auditor, PM, Team Member all lose visibility. Working budget is unchanged.
export const canViewSanctioned = (role) => ["Admin", "Accounts"].includes(role);
export const canUploadSanctioned = (role) => role === "Admin";
export const canUploadWorking = (role) => ["Admin", "Accounts"].includes(role);
export const canEditMasters = (role) => role === "Admin";
// Legacy alias — kept for pages that import canSeeBudgetA. Points at the new rule.
export const canSeeBudgetA = canViewSanctioned;
// UC (Phase 2 will fully wire) — Admin + Accounts prepare, Admin only finalises.
export const canPrepareUC = (role) => ["Admin", "Accounts"].includes(role);
export const canFinaliseUC = (role) => role === "Admin";
